import React from 'react'
import { useSearchParams } from 'react-router-dom'

//UI
import Head from '@/components/Head'
import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import VendorDetailForm from '../components/VendorDetailForm'
import { useTranslation } from 'react-i18next'

const VendorRegisterPage = () => {
  const [searchParams] = useSearchParams()
  const requestorEmail = searchParams.get('requestor') ?? ''
  const { t } = useTranslation()

  return (
    <>
      <Head title={'Register as Siemens Vendor'} />
      <Flex h="100vh" bg="#000028" justify="center" align="center" direction={'column'} gap="8">
        <Flex minW={[320, 728, 1200]}>
          <Flex gap="5" alignItems={'center'}>
            <Box>
              <Image w="150px" objectFit="cover" src="https://images.sw.cdn.siemens.com/logo/logo-white.svg" />
            </Box>
            <Text color="white" fontWeight={'bold'} fontSize="2xl">
              {t('E_APPROVAL_SYSTEM')}
            </Text>
          </Flex>
        </Flex>
        <Box bg="rgba(255, 255, 255, 1)" p="5" minW={[320, 728, 1200]} borderRadius={'2xl'}>
          <Heading mb="5" py="2">
            {t('REGISTER_PAGE_TITLE')}
          </Heading>

          {requestorEmail === '' && <Text color={'red'}>{t('REGISTER_PAGE_ACCESS_DENIED')}</Text>}

          {requestorEmail !== '' && <VendorDetailForm requestorEmail={requestorEmail}></VendorDetailForm>}
        </Box>
      </Flex>
    </>
  )
}

export default VendorRegisterPage
